import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactSection = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/33651988621', '_blank');
  };

  return (
    <div className="bg-primary/5 rounded-lg p-8 border border-primary/20">
      <div className="text-center max-w-2xl mx-auto">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="MessageCircle" size={32} color="var(--color-primary)" />
        </div>
        
        <h2 className="text-2xl font-bold text-foreground mb-3">
          Besoin d'aide ?
        </h2>
        
        <p className="text-muted-foreground mb-6">
          Notre équipe est disponible pour répondre à toutes vos questions sur nos services d'expédition entre la France et la Côte d'Ivoire.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            variant="default"
            size="lg"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={handleWhatsAppClick}
          >
            Contacter sur WhatsApp
          </Button>
          
          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="Phone" size={18} />
            <span className="text-sm font-medium">06 51 98 86 21</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;